export function isRestrictionWithAutoProgress(restriction) {
    return Object.prototype.hasOwnProperty.call(restriction, 'autoProgress');
}
export function isRestrictable(item) {
    return Object.prototype.hasOwnProperty.call(item, 'restriction');
}
